module.exports = __webpack_public_path__ + "static/img/webapplication.914a206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/webapplication.png
// module id = geta
// module chunks = 0